import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { CheckCircleOutline as CheckIcon } from '@mui/icons-material';
import { CONTENT_MAX_WIDTH } from '../../components/layout/PageLayout';
import LoginForm from '../../components/auth/LoginForm';

/** What an account is actually for, said plainly next to the form. */
const BENEFITS = [
  'écrire et répondre sur le fil du quartier',
  'prendre rendez-vous chez un professionnel',
  'noter les artisans chez qui vous êtes passé',
  "tenir la liste d'entretien de votre logement",
];

/**
 * The sign-in page.
 *
 * The column beside the form answers the question somebody actually asks in
 * front of a login box — "why would I bother" — which the bare centred card
 * this replaces left hanging.
 */
function Login() {
  return (
    <Box sx={{ bgcolor: 'background.default', flex: 1, display: 'flex', alignItems: 'center' }}>
      <Container maxWidth={CONTENT_MAX_WIDTH} sx={{ py: { xs: 4, md: 7 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          sx={{ gap: { xs: 4, md: 7 }, alignItems: 'center', justifyContent: 'center' }}
        >
          <LoginForm />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 420, width: '100%' }}>
            <Typography variant="h3" component="h2">
              Avec un compte, vous pouvez&nbsp;:
            </Typography>
            {BENEFITS.map((benefit) => (
              <Stack key={benefit} direction="row" sx={{ gap: 1.5, alignItems: 'flex-start' }}>
                <CheckIcon sx={{ color: 'secondary.main', fontSize: 24, flexShrink: 0 }} />
                <Typography variant="body1">{benefit}</Typography>
              </Stack>
            ))}
            <Typography variant="body2" sx={{ mt: 1 }}>
              L'annuaire, le fil et l'agenda se lisent sans compte.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}

export default Login;
